<template>
  <div class="spinning-wheel-users-report">
    <div class="category-top-bar sticky-header">
      <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back" @click.prevent="back">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </p>
        <div class="text-right">
          <h5 class="mar-bt-0">{{ pageTitle }}</h5>
        </div>
      </div>
    </div>

    <div class="card mar-to-15">
      <div class="card-content">
        <div :class="(loading ? 'show-loader' : 'hide-loader')">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div>

        <el-table
          :data="tableData"
          :empty-text="$t('gestiune.noData')"
          style="width: 100%;"
          @row-click="toggleExpand"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table :data="props.row.spins || []" size="mini" style="width: 100%;">
                <el-table-column prop="spin_id" :label="$t('spinningWheel.spinId')" width="90" />
                <el-table-column :label="$t('spinningWheel.dateWon')" min-width="140">
                  <template slot-scope="s">{{ formatDateTime(s.row.date_won) }}</template>
                </el-table-column>
                <el-table-column prop="status" :label="$t('spinningWheel.status')" width="110" />
                <el-table-column :label="$t('spinningWheel.dateRedeemed')" min-width="140">
                  <template slot-scope="s">{{ s.row.date_redeemed ? formatDateTime(s.row.date_redeemed) : '—' }}</template>
                </el-table-column>
                <el-table-column prop="qualifying_order_id" :label="$t('spinningWheel.qualifyingOrder')" width="130" />
              </el-table>
            </template>
          </el-table-column>
          <el-table-column prop="user_id" :label="$t('customers.id')" width="80" />
          <el-table-column :label="$t('spinningWheel.user')" min-width="160" show-overflow-tooltip>
            <template slot-scope="props">
              {{ [props.row.firstname, props.row.lastname].filter(Boolean).join(' ') || props.row.email || ('#' + props.row.user_id) }}
            </template>
          </el-table-column>
          <el-table-column prop="wins" :label="$t('spinningWheel.wins')" width="80" />
          <el-table-column prop="used" :label="$t('spinningWheel.used')" width="80" />
          <el-table-column prop="available" :label="$t('spinningWheel.available')" width="100" />
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Table, TableColumn } from 'element-ui'

Vue.use(Table)
Vue.use(TableColumn)

export default {
  props: {
    route: { type: Object, default: () => ({}) }
  },
  data () {
    return {
      loading: false,
      tableData: [],
      rewardId: null,
      pageTitle: ''
    }
  },
  created () {
    this.rewardId = (this.route.params && this.route.params.rewardId) ||
      (this.$route.params && this.$route.params.rewardId)
    this.pageTitle = (this.$route.query && this.$route.query.title) || this.$t('spinningWheel.users')
    this.loadReport()
  },
  methods: {
    back () {
      const q = this.$route.query || {}
      if (q.campaign_id) {
        this.$router.replace({
          path: '/reports/spinning-wheel/' + q.campaign_id + '/rewards',
          query: {
            title: '',
            date_from: q.date_from || '',
            date_to: q.date_to || ''
          }
        })
        return
      }
      this.$bus.$emit('close-modal')
    },
    toggleExpand () {},
    loadReport () {
      if (!this.rewardId) return
      this.loading = true
      const params = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      const q = this.$route.query || {}
      if (q.date_from) params.date_from = q.date_from
      if (q.date_to) params.date_to = q.date_to
      this.apiRequest('/reports/spinning-wheel/rewards/' + this.rewardId + '/users', 'GET', params, (response) => {
        this.loading = false
        if (response.status && response.data) {
          this.tableData = response.data.users || []
          if (response.data.reward && response.data.reward.name) {
            this.pageTitle = response.data.reward.name
          }
        } else {
          this.tableData = []
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/SpinningWheelUsersReport.vue